import Vue from 'vue';
import store from '@/store';

export default function NotificationPlugin(vue: typeof Vue, options?: any): void {
  vue.prototype.$showConfirm = async (title: string, text: any) => {
    text = Array.isArray(text) ? text.join('<br />') : text;

    return await vue.prototype.$dialog.warning({
      title: title || 'هشدار',
      text,
      actions: {
        false: 'خیر',
        true: 'بله'
      },
      icon: false,
      showClose: false
    });
  };

  vue.prototype.$showNotification = (type: string, text: string) => {
    const notificationOptions = { position: 'top' };

    switch (type) {
      case 'success':
        vue.prototype.$dialog.message.success(text, notificationOptions);
        break;
      case 'info':
        vue.prototype.$dialog.message.info(text, notificationOptions);
        break;
      case 'warning':
        vue.prototype.$dialog.message.warning(text, notificationOptions);
        break;
      case 'error':
        vue.prototype.$dialog.message.error(text, notificationOptions);
        break;
      default:
        vue.prototype.$dialog.message.info(text, notificationOptions);
        break;
    }
  };

  vue.prototype.$showAlert = async (text: any, color?: string, title?: string) => {
    text = Array.isArray(text) ? text.join('<br />') : text;

    const alertOptions = {
      title: title || 'توجه',
      text,
      color: color || 'primary',
      actions: [{ text: 'متوجه شدم', color: 'grey darken-4', outlined: true }],
      showClose: false,
      icon: false
    };

    vue.prototype.$dialog.warning(alertOptions);
  };

  vue.prototype.$showSuccessOperationAlert = async () => {
    const alertOptions = {
      title: 'توجه',
      text: 'عملیات با موفقیت انجام شد',
      color: 'success',
      actions: [{ text: 'متوجه شدم', color: 'grey darken-4', outlined: true }],
      showClose: false,
      icon: false
    };

    vue.prototype.$dialog.warning(alertOptions);
  };

  vue.prototype.$showLoading = () => store.dispatch('showLoading');
  vue.prototype.$hideLoading = () => store.dispatch('hideLoading');
  vue.prototype.$showNavigationLoading = () => store.dispatch('showNavigationLoading');
  vue.prototype.$hideNavigationLoading = () => store.dispatch('hideNavigationLoading');
}

declare module 'vue/types/vue' {
  interface Vue {
    $showAlert: any;
    $showConfirm: any;
    $showNotification: any;
    $showLoading: any;
    $hideLoading: any;
    $showNavigationLoading: any;
    $hideNavigationLoading: any;
    $showSuccessOperationAlert: any;
  }
}
